export default __webpack_public_path__ + "static/7-d827f9dbdbd4b97b37e91e172131d45a.png";